export const setItem = (name: string, value: string): void => {
  try {
    localStorage.setItem(name, value);
  }
  catch (error) {
    console.error(`Error saving item to localStorage: ${error}`);
  }
}

export const getItem = (name: string): string => {
  try {
    const value = localStorage.getItem(name);
    if (value === null) {
      return '';
    }
    return value;
  } catch (error) {
    console.error(`Error retrieving item from localStorage: ${error}`);
    return '';
  }
}

export const clearStorage = (): void => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error(`Error clearing localStorage: ${error}`);
  }
}